import { hasPricedVendorSelection, isPostPaidPaymentTiming } from '../../utils/postPaidPricing';
import { type VolumeClaimTemplateItem, type VolumeItem, isVolumeClaimTemplateItem, isVolumeStorageItem } from './volumeTypes';

export type { VolumeItem } from './volumeTypes';
export { VolumeMountTab, VolumeMountType, isVolumeClaimTemplateItem, isVolumeStorageItem } from './volumeTypes';

export function normalizeContainerVolumeList(raw: unknown): VolumeItem[] {
  return Array.isArray(raw) ? (raw as VolumeItem[]) : [];
}

/** 将已有 PVC 选项转换为卷名称到容量的展示映射。 */
export function buildMountedVolumeCapacityMap(options: readonly { value: string; storage?: string }[]): Map<string, string> {
  return new Map(
    options.flatMap((item) => {
      const value = String(item.value || '').trim();
      const storage = String(item.storage || '').trim();
      return value && storage ? [[value, storage] as const] : [];
    }),
  );
}

function isConfiguredContainerVolume(item: VolumeItem | undefined): boolean {
  if (!item) return false;
  if (isVolumeClaimTemplateItem(item)) {
    return Boolean(String(item.volumeName ?? '').trim() && String(item.storageClass ?? '').trim());
  }
  if (isVolumeStorageItem(item)) {
    return Boolean(String(item.selected ?? '').trim() && String(item.volumeName ?? '').trim());
  }
  return false;
}

/** 参与计价的共享卷声明模板：有容量；后付费已选厂商设备时容量可空 */
function isPricedClaimTemplateVolume(item: VolumeItem | undefined, options?: { paymentTiming?: string }): item is VolumeClaimTemplateItem {
  if (!isVolumeClaimTemplateItem(item)) return false;
  if (!String(item.volumeName ?? '').trim()) return false;
  if (Number(item.volumeCapacity) > 0) return true;
  return isPostPaidPaymentTiming(options?.paymentTiming) && hasPricedVendorSelection(item.pricing);
}

export function listPricedClaimTemplateVolumes(
  volumes: VolumeItem[] | undefined,
  options?: { paymentTiming?: string },
): VolumeClaimTemplateItem[] {
  return normalizeContainerVolumeList(volumes).filter((item) => isPricedClaimTemplateVolume(item, options));
}

export function filterConfiguredContainerVolumes(volumes: VolumeItem[] | undefined): VolumeItem[] {
  return normalizeContainerVolumeList(volumes).filter(isConfiguredContainerVolume);
}

/** PVC 声明模板中缺少存储类的下标 */
export function claimTemplateIndexesMissingStorageClass(volumes: unknown): number[] {
  return normalizeContainerVolumeList(volumes).flatMap((item, index) =>
    isVolumeClaimTemplateItem(item) && !String(item.storageClass ?? '').trim() ? [index] : [],
  );
}
